import React, {useState, useEffect} from 'react';
import {View, StyleSheet, Animated, Text} from 'react-native';
import {primaryState50, primaryState800, FONT_FAMILY_SEMI_BOLD} from './utils';
import {useRef} from 'react';

const ThreeDotsLoader = props => {
   // const [dotOne] = useState(new Animated.Value(0));
   // const [dotTwo] = useState(new Animated.Value(0));
   // const [dotThree] = useState(new Animated.Value(0));
   const dotOne = useRef(new Animated.Value(0)).current;
   const dotTwo = useRef(new Animated.Value(0)).current;
   const dotThree = useRef(new Animated.Value(0)).current;

   const runAnimation = () => {
      const anim = Animated.sequence([
         Animated.timing(dotOne, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotTwo, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotThree, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotOne, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotTwo, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
         Animated.timing(dotThree, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
         }),
      ]);
      anim.start(() => runAnimation());
      return anim;
   };

   useEffect(() => {
      const anim = runAnimation();
      return () => {
         anim.stop();
         dotOne.removeAllListeners();
         dotTwo.removeAllListeners();
         dotThree.removeAllListeners();
      };
   }, []);

   const scaleDotOne = dotOne.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });

   const scaleDotTwo = dotTwo.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });

   const scaleDotThree = dotThree.interpolate({
      inputRange: [0, 1],
      outputRange: [0.5, 1],
   });

   //const justifyData = props.justifyData ? 'center' : 'flex-start';
   const justifyData = 'center';

   return (
      <View
         style={{justifyContent: justifyData, alignItems: 'center', flex: 1}}>
         <View style={styles.CircleShape}>
            <View style={styles.container}>
               <Animated.View
                  style={[styles.dot, {transform: [{scale: scaleDotOne}]}]}
               />
               <Animated.View
                  style={[styles.dot, {transform: [{scale: scaleDotTwo}]}]}
               />
               <Animated.View
                  style={[styles.dot, {transform: [{scale: scaleDotThree}]}]}
               />
            </View>
         </View>
         <Text
            style={{
               fontSize: 20,
               color: primaryState800,
               fontWeight: '600',
               textAlign: 'center',
               fontFamily: FONT_FAMILY_SEMI_BOLD,
               marginTop: -5,
            }}>
            {props.title}
         </Text>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
   },
   dot: {
      width: 14,
      height: 14,
      marginHorizontal: 4,
      backgroundColor: 'blue',
   },
   CircleShape: {
      width: 120,
      height: 120,
      borderRadius: 120 / 2,
      backgroundColor: primaryState50,
      //margin: 24,
      marginHorizontal: 24,
      marginBottom: 24,
   },
});

export default ThreeDotsLoader;
